// extracted by mini-css-extract-plugin
export var logoWrapper = "hB_BT";